module.exports = __webpack_public_path__ + "img/1725847012925-screenshot-1725846997645.png.9f34a048.webp";